export var SessionStorageEnum;
(function (SessionStorageEnum) {
    SessionStorageEnum["SelectedModuleID"] = "selectedModuleID";
    SessionStorageEnum["SelectedJobID"] = "selectedJobID";
    SessionStorageEnum["IsUserAuthenticated"] = "isUserAuthenticated";
    SessionStorageEnum["Nonce"] = "nonce";
})(SessionStorageEnum || (SessionStorageEnum = {}));
